import { createSlice, createAsyncThunk } from '@reduxjs/toolkit' // Importing Redux Toolkit utilities
import { AxiosError, AxiosResponse } from 'axios' // Importing Axios types for error and response handling
import { constructApiEndpoint, httpPost } from '@school/common/common-utils/helpers/httpClient' // Helper functions for building API endpoints and making POST requests
import { TESTCODE } from '@school/common/common-utils/constants/slice-constants' // Constant identifier used for Redux slice
import { RootState } from '@school/store/store' // Type for accessing the application's root Redux state
import { ErrorResponse, TestCodeType } from '@school/schemas/typeInterface' // Custom types for API error and test code data

// Async thunk for check test code list
export const testCodeList = createAsyncThunk(TESTCODE, async (_, { rejectWithValue }) => {
  try {
    const payload = {
      pageSize: 0,
      pageNumber: 1,
      filter: [],
    }
    const endpoint = constructApiEndpoint(TESTCODE, {})
    const response: AxiosResponse<TestCodeType[]> = await httpPost(endpoint, payload)
    return response.data
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      const errorData = error.response?.data as ErrorResponse
      const message = errorData?.message?.[0] || error.message || 'Failed to fetch TEST CODE'
      return rejectWithValue(message)
    }
    return rejectWithValue('An unexpected error occurred')
  }
})

interface initialProps {
  testCode: TestCodeType[]
  loading: boolean
  error: unknown
}
const initialState: initialProps = {
  testCode: [],
  loading: false,
  error: null,
}

// Create slice
const DropDownSlice = createSlice({
  name: 'drop',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch address list
      .addCase(testCodeList.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(testCodeList.fulfilled, (state, action) => {
        state.loading = false
        state.testCode = action.payload
      })
      .addCase(testCodeList.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})
// Selectors
export const selectTestCode = (state: RootState) => state.drop.testCode
export default DropDownSlice.reducer
